<div class="horizontalMenucontainer">
  <div class="page">
    <div class="page-main">
      <app-header></app-header>
      <div class="app-content main-content">
        <app-breadcrumb></app-breadcrumb>
        <div>
          <router-outlet><app-loader></app-loader></router-outlet>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</div>
